import React, { useState } from "react";
import { Button } from "@picklebet/ui";
import * as styles from "./SumsubVerifyButton.module.scss";
import { verificationService } from "features/account/services/verification";
import { buildVerificationErrorInfo } from "features/account/utils/verificationError";
import type { VerificationErrorInfo } from "features/account/types/VerificationError";
import { VerificationError } from "../VerificationError";

export const SumsubVerifyButton = ({
  attemptId,
  destination,
  onSuccess,
}: { attemptId: string; destination: string; onSuccess: () => void }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<VerificationErrorInfo | null>(null);

  const handleClick = async () => {
    setIsLoading(true);
    setError(null);

    const result = await verificationService.submitAttemptData({
      attemptType: "SumsubIdentityDocuments",
      attemptId: attemptId,
      terms: true,
      destination: destination,
    });

    if (!result.ok) {
      setError(
        buildVerificationErrorInfo({ source: "submit", cause: result.error }),
      );
      setIsLoading(false);
      return;
    }

    onSuccess();

    setIsLoading(false);
  };

  return (
    <>
      {error && (
        <VerificationError
          error={error}
          variant="inline"
          title="We couldn't start verification"
          actions={
            <Button onClick={handleClick} size="md" variant="danger">
              Retry
            </Button>
          }
        />
      )}
      <div className={styles.verifyButtonWrapper}>
        <Button
          onClick={handleClick}
          className={styles.verifyButton}
          loading={isLoading}
        >
          Verify Now
        </Button>
        <span className={styles.caption}>Powered by Sumsub.</span>
      </div>
    </>
  );
};
